
import FindUser from './FindUser';
import './App.css';

function App() {
  return (
    <div className="App">
      <FindUser />
    </div>
  );
}

export default App;
